export interface INotificationsSettingsInput {
    orderScheduled: boolean;
    orderInRoute: boolean;
    orderSucceeded: boolean;
    orderFailed: boolean;
    includeEstimatedArrival: boolean;
    includeScheduledArrival: boolean;
    includeOrderItems: boolean;
    notificationMargin: number;
    showContactInfo: boolean;
    toasterAlertTypes: string[];
    toasterEventTypes: string[];
}
